import { FC, Fragment, memo } from "react";
import { FormikHandlers } from "formik";
import { FilterItemOperatorType } from "../../../FilterItemOperatorType";
import {
  FilterItem,
  Operator,
  ResourceType,
  GetUsersMeAccountsResourceTypesByResourceTypeInstanceFamiliesApiArg,
  useGetUsersMeAccountsResourceTypesByResourceTypeInstanceFamiliesQuery,
} from "../../../../../../../../services/cloudchipr.api";
import {
  AutocompleteFilterBody,
  AutocompleteFilterBodyProps,
} from "../AutocompleteFilterBody";

export type InstanceFamilyFilterResourceType =
  GetUsersMeAccountsResourceTypesByResourceTypeInstanceFamiliesApiArg["resourceType"];

interface InstanceFamilyFilterProps extends AutocompleteFilterBodyProps {
  resourceType: ResourceType;
  filter: FilterItem;
  operators?: Operator[];
  onChange: FormikHandlers["handleChange"];
}

export const InstanceFamilyFilter: FC<InstanceFamilyFilterProps> = memo(
  ({ resourceType, operators, filter, onChange, ...props }) => {
    const { data, isLoading } =
      useGetUsersMeAccountsResourceTypesByResourceTypeInstanceFamiliesQuery({
        resourceType: resourceType as InstanceFamilyFilterResourceType,
      });

    return (
      <Fragment>
        <FilterItemOperatorType
          onChange={onChange}
          options={operators}
          value={filter.operator || "in"}
        />

        <AutocompleteFilterBody
          {...props}
          options={data ?? []}
          isLoading={isLoading}
          label="Instance Family"
          selectedValue={Array.isArray(filter?.value) ? filter.value : []}
        />
      </Fragment>
    );
  },
);
